/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplicationUrlDTO,
    ApplicationUrlDTOFromJSON,
    ApplicationUrlDTOFromJSONTyped,
    ApplicationUrlDTOToJSON,
} from './ApplicationUrlDTO';

/**
 * 
 * @export
 * @interface ConfigDTO
 */
export interface ConfigDTO {
    /**
     * 
     * @type {string}
     * @memberof ConfigDTO
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigDTO
     */
    secured?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigDTO
     */
    securityLevel?: ConfigDTOSecurityLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfigDTO
     */
    userManualUrl?: string;
    /**
     * 
     * @type {Array<ApplicationUrlDTO>}
     * @memberof ConfigDTO
     */
    applicationUrls?: Array<ApplicationUrlDTO>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ConfigDTO
     */
    config?: { [key: string]: string; };
}

/**
* @export
* @enum {string}
*/
export enum ConfigDTOSecurityLevelEnum {
    Oidc = 'OIDC',
    Password = 'PASSWORD',
    None = 'NONE'
}

export function ConfigDTOFromJSON(json: any): ConfigDTO {
    return ConfigDTOFromJSONTyped(json, false);
}

export function ConfigDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'secured': !exists(json, 'secured') ? undefined : json['secured'],
        'securityLevel': !exists(json, 'securityLevel') ? undefined : json['securityLevel'],
        'userManualUrl': !exists(json, 'userManualUrl') ? undefined : json['userManualUrl'],
        'applicationUrls': !exists(json, 'applicationUrls') ? undefined : ((json['applicationUrls'] as Array<any>).map(ApplicationUrlDTOFromJSON)),
        'config': !exists(json, 'config') ? undefined : json['config'],
    };
}

export function ConfigDTOToJSON(value?: ConfigDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'secured': value.secured,
        'securityLevel': value.securityLevel,
        'userManualUrl': value.userManualUrl,
        'applicationUrls': value.applicationUrls === undefined ? undefined : ((value.applicationUrls as Array<any>).map(ApplicationUrlDTOToJSON)),
        'config': value.config,
    };
}

